import rangeSliders from '../../components/rangeSlider/rangeSliders';

require('../../components/collection/FacetsFiltersForm');
require('../../components/collection/PriceRange');
require('../../components/collection/FacetRemove');
require('../../components/collection/ShowMoreButton');

rangeSliders();
